import { authMutationsSlice } from './auth';
import { profileMutationsSlice } from './profile'
import { siteMutationsSlice } from './sites';

export const { 
  useSubmitAccountManagerFormMutation,
  useSubmitBrandWorkshopFeedbackMutation,
  useEventMutation,
} = siteMutationsSlice;

export const {
  useSubmitProfileDetailsFormMutation
} = profileMutationsSlice;

export const {
  useChangeTempPasswordMutation,
  useForgotPasswordMutation,
  useSetPasswordMutation,
  useSetPasswordFromProfilePageMutation,
} = authMutationsSlice;
